module.exports = __webpack_public_path__ + "static/car3-dff0ad8cd0f2d04e79c94d25a8966e5f.png";